import EditNewsPage from "./EditNewsPage";

export default EditNewsPage;
